import script from "./AppLanguage.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppLanguage.vue?vue&type=script&setup=true&lang=ts"

import "./AppLanguage.vue?vue&type=style&index=0&id=5133afec&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5133afec"]])

export default __exports__